import { createRouter, createWebHistory } from 'vue-router'
//import AppDetails from '@/views/AppDetails.vue'
import AppProducts from '@/views/AppProducts.vue'
import AppProductsCategory from '@/views/AppProductsCategory'
import ProductService from '@/services/ProductService'
import AppProductsSearch from '@/views/AppProductsSearch'
import store from '@/store';

const routes = [
    {
        path: '/',
        name: 'AppProducts',
        component: AppProducts,
        props: {
            fromHome:true
        },
        meta: {
            reload: true,
        }
    },
    /* {
        path: '/:slug',
        name: 'AppDetails',
        component: AppDetails,
        props(route) {
          ProductService.getProduct(route.params.slug)
          .then(response => {
            return response.data
          })
        }
    },*/
	{
        path: '/:category/:sub_category',
        name: 'AppProductsCategory',
        component: AppProductsCategory,
    },
    {
        path: '/category/',
        name: 'AppSelectedCategory',
        component: AppProductsCategory,
    },
	{
        path: '/search/:term',
        name: 'AppProductsSearch',
        component: AppProductsSearch,
    }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from) => {

    if('AppProducts' != from.name) {
        if(store.getters.getSelectedCategories) {
            //await store.dispatch('searchMultiple', store.getters.getSelectedCategories)
        }
    }
})

router.afterEach(async(to, from) => {
    if('AppProducts' != from.name && 'AppSelectedCategory' != from.name) {

        if(store.getters.getSelectedCategories) {
            await store.dispatch('searchMultiple', store.getters.getSelectedCategories)
                .then( () => {
                    setTimeout(function(){
                        const element = document.getElementById(from.params.slug)
                        if(element){
                            window.scroll({left:element.offsetLeft, top:element.offsetTop, behavior:'smooth'})
                        }
                    }, 100)
                })
        }
    }
})

router.beforeResolve(async to => {
    if(to.name) {
        // manage app version
        return await ProductService.getAppVersion()
            .then(response => {
                const storages = Object.keys(localStorage)

                if (!localStorage.getItem('app_version')) {
                    localStorage.setItem('app_version', response.data);
                }

                if(localStorage.getItem('app_version') != response.data) {

                    for (let i = 0; i < storages.length ; i++) {
                        localStorage.removeItem(storages[i]);
                    }
                }
            })
    }
})


export default router
